import React, { useState, useEffect } from 'react';

function CoursePdf(props) {
  return (

  <div className="">
      <div className="Header">
        <span className="cat-title">
          {localStorage.getItem('pdfTitle')}
            <i
              className="icon-arrow-down-sign-to-navigate"
              onClick={() => props.history.goBack()} ></i>
          </span>
      </div>
      <div style={{position:'relative'}}>
        <div style={{backgroundColor:'#fff', height:'50px' , width:'50px', position:'absolute', top:'7px',  zIndex:'999998',      opacity:'0.1', left:'calc(100% - 53px)' }}></div>
          <iframe 
            src={`https://docs.google.com/gview?url=${localStorage.getItem('pdfLink')}&embedded=true`}
            style={{width:'100%', height:'89vh',}} frameBorder="0"></iframe>
      </div>
    </div>
  )
}
export default CoursePdf
